/**
 * Pages that access groups grant, same keys as the API
 * (apps/api/src/core/access/app-modules.ts). Admin belongs to the
 * platform-admin role; profile and settings are open to every signed-in user.
 */
export const APP_MODULES = ["digital-twin", "quiz", "scenarios", "analyze-stations"] as const;

export type AppModule = (typeof APP_MODULES)[number];

export const MODULE_INFO: Record<AppModule, { label: string; path: string }> = {
  "digital-twin": { label: "Digital Twin", path: "/digitaltwin" },
  quiz: { label: "Road Quiz", path: "/digitaltwin/quiz" },
  scenarios: { label: "Scenarios", path: "/digitaltwin/scenarios" },
  "analyze-stations": { label: "Analyze Stations", path: "/analyzeStation" },
};

export function isAppModule(value: string): value is AppModule {
  return (APP_MODULES as readonly string[]).includes(value);
}
